export var getIds = id => id ? {
  root: id,
  text: "".concat(id, "__text"),
  input: "".concat(id, "__input") // only used on web
} : undefined;
//# sourceMappingURL=getIds.js.map